const content = {
    netflix_watch_history: {
        en: {
            summary_html: '',
            summary_no_video_html: `
              <p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to
                  hit record and scroll through your Netflix Viewing Activity.</p>
              <div class="text-with-icon">
                <div class="icon">⚠️</div>
                <div class="text">
                  We’ll only pay MSR rewards for videos that fully match the steps below.
                </div>
              </div>
              <div class="text-with-icon">
                <div class="icon">⚠️</div>
                <div class="text">
                  This Retro data task is done by logging into Netflix on your device's web browser and not via the
                  Netflix app.
                </div>
              </div>`,
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: `<p>Go to <a href="https://www.netflix.com/viewingactivity" target="_blank">netflix.com/viewingactivity</a>
                  (tapping the link will open your browser).</p>`
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: `<p>Start the screen recording.</p>`
              },
              {
                step_type: 'numbered_step',
                number: '3',
                description_html: '<p>Starting at the top, scroll down through the <b>last 3 months</b> of your viewing activity.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '4',
                description_html: `<p>Make sure all of your viewing activity has been on screen during the screen recording, then
                  stop the video recording.</p>`
              }
            ],
        }
    }
};

export const netflixDataTypes = {
    'netflix_watch_history': {
        data_type: 'netflix_watch_history',
        data_type_description: 'Netflix Watch History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/netflix-watch-history/logo.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.netflix_watch_history,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.netflix_watch_history,
        },
      },
}